<template>
  <section id="Suites">
    <div id="Suites-selector"></div>
    <b-container id="suites-bottom-container">
      <div id="suites-bottom-text-blurb">
        <img src="@/assets/logos/logo_GLF-white.svg" alt="Globe Life Field" />
        <h2>Suites</h2>
        <div class="line"></div>
        <p>
          Looking for something a little more special for your group’s visit to
          Globe Life Field? Elevate your game with a nightly suite rental.
        </p>
        <a
          href="https://rangers.fanportal-mlb.com/suites"
          target="_blank"
          class="red-button"
        >
          Explore Suites
        </a>
      </div>
    </b-container>
    <div id="suites-images">
      <div class="suites-bottom-image" id="suites-bottom-image-1">
        <img
          src="@/assets/images/Suites-bottom/suites-1.jpg"
          alt="Marble Suite"
        />
      </div>
      <div class="suites-bottom-image" id="suites-bottom-image-2">
        <img src="@/assets/images/Suites-bottom/suites-2.jpg" alt="Bar Suite" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Suites",
};
</script>

<style lang="scss" scoped>
#Suites {
  position: relative;
  margin-top: 25px;
  background: linear-gradient(135deg, #252525 0%, #111111 100%);
  padding: 6% 0;
  margin-bottom: 25px;
  @media (max-width: $xl) {
    padding: 3% 0;
  }
  @media (max-width: $lg) {
    display: flex;
    flex-direction: column;
    padding: 70px 0 0 0;
    margin: 6px 0 7px 0;
  }
  #suites-bottom-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    #suites-bottom-text-blurb {
      text-align: left;
      color: #ffffff;
      @media (min-width: $lg) {
        flex-basis: 33%;
      }
      @media (max-width: $lg) {
        margin-bottom: 71px;
      }
      h2 {
        font-family: BertholdCondensed;
        font-weight: 700;
        font-size: 92px;
        text-transform: uppercase;
        letter-spacing: 0;
        line-height: 74px;
        margin-top: 32px;
        margin-bottom: 19px;
      }
      p {
        margin-top: 34px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 23px;
        margin-bottom: 24px;
      }
      .red-button {
        font-family: Gotham;
        font-weight: 900;
        font-size: 13px;
        line-height: 15px;
        letter-spacing: 0;
        color: #ffffff;
        text-transform: uppercase;
        text-decoration: none;
        width: 156px;
        height: 40px;
        border-radius: 8px;
        padding: 13px 18px 12px 22px;
        border: none;
        background-color: #c10230;
      }
    }
  }
  #suites-images {
    position: absolute;
    right: 10px;
    top: 10px;
    display: flex;
    flex-direction: row;
    height: calc(100% - 20px);
    // @media (max-width: $xl) {
    //   top: 50%;
    //   transform: translateY(-50%);
    // }
    @media (max-width: $lg) {
      position: relative;
      top: auto;
      right: auto;
      height: auto;
      width: 100%;
      transform: none;
    }
    .suites-bottom-image {
      @media (max-width: $lg) {
        width: calc((50% - 2.5px));
      }
      img {
        height: 100%;
        @media (max-width: $lg) {
          height: auto;
          width: 100%;
          object-fit: contain;
        }
      }
    }
    #suites-bottom-image-2 {
      margin-left: 10px;
    }
  }
}
</style>
